import { useForm } from "../../src/hooks/useForm";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../src/utils/constant";

const InventoryTransferTable = ({ products, setProducts }) => {
  const {
    handleInputChange,
    formData,
    submitForm,
    setFormData,
    setError,
    error,
  } = useForm();

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [units, setUnits] = useState([]);
  useEffect(() => {
    axios
      .get(API_URL + "/unit?status=ACTIVE", {
        withCredentials: true,
      })
      .then((response) => {
        setUnits(response.data.data);
      });
  }, []);

  return (
    <div className="table-container">
      <table className="x-table product-list-table">
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Barcode</th>
            <th>Qty</th>
            <th>SKU</th>
          </tr>
        </thead>
        <tbody>
          {products?.map((item) => (
            <tr key={item.product_id}>
              <td>{item.product_name}</td>
              <td>{item.barcode}</td>
              <td>
                <input
                  type="number"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  min={1}
                  id={`qty-${item.product_id}`}
                  value={item.quantity}
                  onChange={(e) => {
                    const quantity = e.target.value;
                    setProducts((prevData) => {
                      return prevData.map((product) =>
                        product.product_id === item.product_id
                          ? { ...product, quantity }
                          : product
                      );
                    });
                  }}
                  className="w-16 border border-solid border-neutral-300 rounded"
                />
              </td>
              <td>
                <select
                  value={item.selectedUnit || ""}
                  onChange={(e) => {
                    const unit_id = e.target.value;
                    setProducts((prev) =>
                      prev.map((product) =>
                        product.product_id === item.product_id
                          ? { ...product, selectedUnit: unit_id }
                          : product
                      )
                    );
                  }}
                  className="x-input dropdown"
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {item.units?.map((u) => (
                    <option key={u.unit_id} value={u.unit_id}>
                      {u.unit_name}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InventoryTransferTable;
